import { render, staticRenderFns } from "./AfiliacionDetail.vue?vue&type=template&id=ec8273c8"
import script from "./AfiliacionDetail.vue?vue&type=script&lang=js"
export * from "./AfiliacionDetail.vue?vue&type=script&lang=js"
import style0 from "./AfiliacionDetail.vue?vue&type=style&index=0&id=ec8273c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports